import Button from '../button/Button';

interface BottomBarProps {
  primaryButtonLabel: string;
  secondaryButtonLabel: string;
  handleSecondaryButtonClick: () => void;
  handlePrimaryButtonClick: () => void;
}

const BottomBar = ({
  primaryButtonLabel,
  secondaryButtonLabel,
  handleSecondaryButtonClick,
  handlePrimaryButtonClick
}: BottomBarProps) => (
  <div className="fixed bottom-0 left-0 flex h-65 w-full items-center justify-between bg-theme pl-14 pr-14 shadow-lg sm:px-[100px] ">
    <Button
      variant="tertiary"
      className="!rounded-3xl !text-xl"
      label={secondaryButtonLabel}
      handleClick={handleSecondaryButtonClick}
    />
    <Button
      label={primaryButtonLabel}
      handleClick={handlePrimaryButtonClick}
      variant="primary"
    />
  </div>
);

export default BottomBar;
